var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPending(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    clipRule: "evenodd",
    fillRule: "evenodd",
    strokeLinejoin: "round",
    strokeMiterlimit: 2,
    viewBox: "0 0 18 18",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#fff",
    fillRule: "nonzero",
    transform: "translate(-27.79925 -29.786)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m36.549 47.295c-2.338 0-4.537-.911-6.19-2.564-3.413-3.413-3.413-8.967 0-12.381 1.654-1.654 3.852-2.564 6.19-2.564s4.537.911 6.19 2.564c1.654 1.654 2.564 3.852 2.564 6.19s-.911 4.537-2.564 6.19c-1.653 1.655-3.851 2.565-6.19 2.565zm0-15.509c-1.804 0-3.5.703-4.776 1.979-2.633 2.634-2.633 6.919 0 9.553 1.276 1.276 2.972 1.979 4.776 1.979s3.5-.703 4.776-1.979 1.979-2.972 1.979-4.776-.703-3.5-1.979-4.776-2.971-1.98-4.776-1.98z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m40 40h-4c-.552 0-1-.448-1-1v-4c0-.552.448-1 1-1s1 .448 1 1v3h3c.552 0 1 .448 1 1s-.448 1-1 1z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPending);
export default __webpack_public_path__ + "static/media/pending.c5c73a73.svg";
export { ForwardRef as ReactComponent };